import axios from 'axios'
import io from "socket.io-client";

import {
  FETCH_BRANCHES,
} from './types';

import { getAPI, getQmaBaseUrl } from '../helpers';

const api = getAPI();
const { REACT_APP_IS_DEV  } = process.env;

let socket = {}; // Declare a variable to hold the Socket.IO client instance
const listenToEvent = (hostname, eventName, updateType, organizationCheck = 0) => (dispatch) => {
  const baseURL = Number(REACT_APP_IS_DEV) ? api : getQmaBaseUrl(hostname);
  console.log(hostname, baseURL);
  socket[eventName] = io(baseURL);
  const startType = updateType + '_START';
  dispatch({ type: startType, payload: 1 });
  socket[eventName].on(`${eventName}-updated`, (res) => {
    console.log(startType, "event", res);
    let type, payload;
    if (res.new_val != null) {
      type = updateType + (res.old_val != null ? '_UPDATE' : '_CREATE');
      payload = res.new_val;
    } else {
      type = updateType + '_DELETE';
      payload = res.old_val;
    }

    // dispatch only if the payload is for the active organization
      dispatch({
        type,
        payload
      })
  });
};

const listenToEventStop = (eventName, updateType) => (dispatch) => {
  if (socket[eventName]) {
    socket[eventName].off(`${eventName}-updated`);
    socket[eventName].disconnect();
    socket[eventName] = null;
  }
  const type = updateType + '_START';
  dispatch({ type, payload: 0 });
}

// Events
export const listenBranches = (hostname) =>
  listenToEvent(hostname, 'admin_branches', 'LISTEN_BRANCHES', 1);
export const listenBranchesStop = () =>
listenToEventStop('admin_branches', 'LISTEN_BRANCHES');

export const fetchBranches = (hostname, organizationId) => async (dispatch) => {
  const baseURL = Number(REACT_APP_IS_DEV) ? api : getQmaBaseUrl(hostname);
  try {
    const res = await axios.get(baseURL + "/admin/branches", { params: { organizationId } });
    dispatch({
      type: FETCH_BRANCHES,
      payload: res.data
    });
  } catch (err) {
    console.log(err);
  }
};
